import { z } from 'zod';

export const ProdutoFornecedorSchema = z.object({
    prf_cod_barra: z.string().nullable(),
    prf_compra_data: z.string().nullable(),
    prf_compra_idpk: z.number().nullable(),
    prf_empresa_idpk: z.number(),
    prf_fornecedor_cnpj_cpf: z.string().nullable(),
    prf_fornecedor_idpk: z.number().nullable(),
    prf_fornecedor_produto_codigo: z.string().nullable(),
    prf_fornecedor_razao_social: z.string().nullable(),
    prf_idpk: z.number(),
    prf_preco_custo: z.number().nullable(),
    prf_preco_venda: z.number().nullable(),
    prf_produto: z.string().nullable(),
    prf_produto_idpk: z.number(),
    prf_quantidade: z.number().nullable(),
    prf_ultima_alteracao: z.string().nullable(),
    prf_unidade: z.string().nullable(),
});

export type ProdutoFornecedor = z.infer<typeof ProdutoFornecedorSchema>;
